import React from 'react';
import mani from '../src/assets/mani.jpg'
import './App.css';
import { Container, Row, Col ,Button, Modal } from 'react-bootstrap';


class App extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      show : false
    }
  }

  render(){

    console.log(this.state.show);

    const handleClose = () => {
      this.setState({
        show: false
      })
    }
    const handleShow = () => {
      this.setState({
        show: true
      })
    }

    const heightOfRow ={
      height: '100vh'
    }
    return(
      <Container>
        <Row style={heightOfRow}>
          <Col md={10} className="mx-auto my-auto">
            <div className="p-5 mycard myround">
              <Row className="align-items-center">
                <Col md={4} sm={12} xs={12}>
                <img src={mani} className="myround img-fluid"/>
                </Col>
                <Col md={8} sm={12} xs={12}>
                  <h1 className="text-white h2 mb-3">Hi, <br/> My name is <strong>Manideep, Gubbala</strong></h1>
                  <p className="text-white">I’m a Designer, Photographer, Digital Marketer, Event Manager, Freelancer.</p>
                  <p className="text-white">I design web applications, mobile applications, logos, posters, videos and everything that a startup needs.</p>
                  <p className="text-white"><strong>Are you looking for?</strong></p>
                  <ul className="list-inline Mylinks">
                    <li className="list-inline-item"><a onClick={handleShow}>My sample works</a></li>
                    <li className="list-inline-item"><a onClick={handleShow}>My photos</a></li>
                    <li className="list-inline-item"><a onClick={handleShow}>My Behance profile</a></li>
                    {/* <li className="list-inline-item"><a>My Social profile</a></li> */}
                  </ul>

                </Col>
              </Row>

              
              <Modal className="bg-warning" show={this.state.show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Thanks for showing interest</Modal.Title>
                </Modal.Header>
                <Modal.Body><p>I'm still finding some free time in my busy schedule to update my portfolio. Meanwhile, you can contact me either on my email or mobile.</p>
                <h4><strong>Phone: <a href="tel:09700337515">09700337515</a></strong></h4>
                <h4><strong>Email: <a href="mailto:manideepami@gmail">manideepami@gmail.com</a></strong></h4>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>Close</Button>
                </Modal.Footer>
              </Modal>
              

            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default App;
